import {
  LuPackageSearch,
  LuQrCode,
  LuRadar,
  LuScale,
  LuShip,
  LuTruck,
} from "react-icons/lu";

/**
 * The actual customer journey through this app, in order — used by both the
 * homepage teaser section and the full /how-it-works page so the two never
 * drift out of sync.
 */
export const HOW_IT_WORKS_STEPS = [
  {
    id: "quote",
    icon: LuPackageSearch,
    title: "Get an instant rate",
    summary: "Describe your goods and see your rate per CBM.",
    detail:
      "Tell us what you're shipping and we classify it automatically: clothes and general goods, electronics, or special-care items like batteries and liquids. You see the rate per CBM for your category before you commit to anything.",
  },
  {
    id: "label",
    icon: LuQrCode,
    title: "Get your shipping label",
    summary: "Enter your details and delivery address once.",
    detail:
      "Fill in your name, phone number, and where in Ghana your goods should end up — area, landmark directions, and an exact GPS pin if you can share your location. We generate a tracking number and a QR-code label to print or screenshot and attach to your cargo.",
  },
  {
    id: "warehouse",
    icon: LuShip,
    title: "Send it to our Guangzhou warehouse",
    summary: "Drop off or courier your goods to the address on your label.",
    detail:
      "Your label shows our Guangzhou warehouse address. Deliver your goods there yourself, or have your supplier ship directly — our team receives and logs every package against your tracking number as it arrives.",
  },
  {
    id: "billing",
    icon: LuScale,
    title: "We weigh it and confirm your bill",
    summary: "Final CBM is measured before your container ships.",
    detail:
      "Once your cargo is in the warehouse, we measure the actual volume and finalize your bill at the confirmed rate for your goods category. You'll see the exact figure — no surprises — before your container departs.",
  },
  {
    id: "tracking",
    icon: LuRadar,
    title: "Track every step",
    summary: "SMS updates plus live status from sailing to arrival.",
    detail:
      "From the moment your container is on board, you get SMS updates and can check live status any time — shipped, arrived in Ghana, cleared and inventoried, out for delivery — all against your tracking number.",
  },
  {
    id: "delivery",
    icon: LuTruck,
    title: "Delivered to your door",
    summary: "Final-mile delivery using your landmark and GPS pin.",
    detail:
      "Our delivery team uses the landmark directions and GPS pin you provided — not just a postal code — to find you. If anything's unclear, we call the number on file before heading out.",
  },
] as const;
